import produce from 'immer';

import { ScorecardRequiredModalAction } from './actions';
import {
  HIDE_SCORECARD_REQUIRED_MODAL,
  SHOW_SCORECARD_REQUIRED_MODAL,
} from './constants';
import { ScorecardRequirement } from './types';

export interface ScorecardRequiredModalState {
  requirement: ScorecardRequirement | null;
}

export const initialState: ScorecardRequiredModalState = {
  requirement: null,
};

const scorecardRequiredModalReducer = (
  state: ScorecardRequiredModalState = initialState,
  action: ScorecardRequiredModalAction,
): ScorecardRequiredModalState =>
  produce(state, draft => {
    switch (action.type) {
      case SHOW_SCORECARD_REQUIRED_MODAL: {
        draft.requirement = action.requirement;
        break;
      }
      case HIDE_SCORECARD_REQUIRED_MODAL: {
        draft.requirement = null;
        break;
      }
      // no default
    }
  });

export default scorecardRequiredModalReducer;
